export default {
  'zh_CN': {
    'cms.website.id.label': 'id',
    'cms.website.id.holder': '请输入id',

    'cms.website.id.required': 'id必填',
    'cms.website.code.label': '站点编码',
    'cms.website.code.holder': '请输入站点编码',
    'cms.website.code.max': '站点编码最多64个字符',
    'cms.website.code.min': '站点编码最小6个字符',
    'cms.website.code.required': '站点编码必填',
    'cms.website.name.label': '站点名称',
    'cms.website.name.holder': '请输入站点名称',
    'cms.website.name.max': '站点名称最多128个字符',
    'cms.website.name.min': '站点名称最小10个字符',
    'cms.website.name.required': '站点名称必填',
    'cms.website.logoUrl.label': '站点Logo',
    'cms.website.logoUrl.holder': '请输入站点Logo',
    'cms.website.logoUrl.max': '站点Logo最多128个字符',

    'cms.website.logoUrl.required': '站点Logo必填',
    'cms.website.publishUrl.label': '发布路径',
    'cms.website.publishUrl.holder': '请输入发布路径',
    'cms.website.publishUrl.max': '发布路径最多128个字符',

    'cms.website.publishUrl.required': '发布路径必填',
    'cms.website.resRoot.label': '资源路径',
    'cms.website.resRoot.holder': '请输入资源路径',
    'cms.website.resRoot.max': '资源路径最多128个字符',

    'cms.website.resRoot.required': '资源路径必填',
    'cms.website.defaultFlag.label': '默认站点',
    'cms.website.defaultFlag.holder': '请输入默认站点',
    'cms.website.defaultFlag.required': '默认站点必填',
    'cms.website.defWorkflowId.label': '审核流程',
    'cms.website.defWorkflowId.holder': '请输入审核流程',
    'cms.website.defWorkflowId.max': '审核流程最多64个字符',

    'cms.website.defWorkflowId.required': '审核流程必填',
    'cms.website.memo.label': '站点简介',
    'cms.website.memo.holder': '请输入站点简介',
    'cms.website.memo.max': '站点简介最多512个字符',

    'cms.website.memo.required': '站点简介必填',
    'cms.website.status.label': '状态',
    'cms.website.status.holder': '请输入状态',

    'cms.website.status.dictionary': () => [{ value: 0, label: '禁用' }, { value: 1, label: '启用' }],
    'cms.website.status.required': '状态必填',
    'cms.website.deptId.label': '部门id',
    'cms.website.deptId.holder': '请输入部门id',

    'cms.website.deptId.required': '部门id必填',
    'cms.website.createTime.label': '创建时间',
    'cms.website.createTime.holder': '请输入创建时间',
    'cms.website.createTime.required': '创建时间必填',
    'cms.website.creator.label': '创建人',
    'cms.website.creator.holder': '请输入创建人',

    'cms.website.creator.required': '创建人必填',
    'cms.website.updateTime.label': '更新时间',
    'cms.website.updateTime.holder': '请输入更新时间',
    'cms.website.updateTime.required': '更新时间必填',
    'cms.website.updater.label': '更新人',
    'cms.website.updater.holder': '请输入更新人',

    'cms.website.updater.required': '更新人必填',
    'cms.website.sort.label': '排序',
    'cms.website.sort.holder': '请输入排序',
    'cms.website.sort.min': '排序最小值0',
    'cms.website.sort.max': '排序最大值为127',
    'cms.website.sort.required': '排序必填',
    'cms.website.deleted.label': '是否删除',
    'cms.website.deleted.holder': '请输入是否删除',
    'cms.website.deleted.required': '是否删除必填',
    'cms.website.tenantId.label': '租户Id',
    'cms.website.tenantId.holder': '请输入租户Id',
    'cms.website.tenantId.max': '租户Id最多32个字符',

    'cms.website.tenantId.required': '租户Id必填',
    'cms.website.version.label': 'version',
    'cms.website.version.holder': '请输入version',

    'cms.website.version.required': 'version必填'
  },
  'zh_TW': {
    'cms.website.id.label': 'id',
    'cms.website.id.holder': '請輸入id',

    'cms.website.id.required': 'id必填',
    'cms.website.code.label': '站点编码',
    'cms.website.code.holder': '請輸入站点编码',
    'cms.website.code.min': '站点编码最多6個字符',

    'cms.website.code.required': '站点编码必填',
    'cms.website.name.label': '站点名称',
    'cms.website.name.holder': '請輸入站点名称',
    'cms.website.name.min': '站点名称最多10個字符',

    'cms.website.name.required': '站点名称必填',
    'cms.website.logoUrl.label': '站点Logo',
    'cms.website.logoUrl.holder': '請輸入站点Logo',

    'cms.website.logoUrl.required': '站点Logo必填',
    'cms.website.publishUrl.label': '发布路径',
    'cms.website.publishUrl.holder': '請輸入发布路径',

    'cms.website.publishUrl.required': '发布路径必填',
    'cms.website.resRoot.label': '资源路径',
    'cms.website.resRoot.holder': '請輸入资源路径',

    'cms.website.resRoot.required': '资源路径必填',
    'cms.website.defaultFlag.label': '默认站点',
    'cms.website.defaultFlag.holder': '請輸入默认站点',

    'cms.website.defaultFlag.required': '默认站点必填',
    'cms.website.defWorkflowId.label': '审核流程',
    'cms.website.defWorkflowId.holder': '請輸入审核流程',

    'cms.website.defWorkflowId.required': '审核流程必填',
    'cms.website.memo.label': '站点简介',
    'cms.website.memo.holder': '請輸入站点简介',

    'cms.website.memo.required': '站点简介必填',
    'cms.website.status.label': '状态',
    'cms.website.status.holder': '請輸入状态',

    'cms.website.status.required': '状态必填',
    'cms.website.deptId.label': '部门id',
    'cms.website.deptId.holder': '請輸入部门id',

    'cms.website.deptId.required': '部门id必填',
    'cms.website.createTime.label': '创建时间',
    'cms.website.createTime.holder': '請輸入创建时间',

    'cms.website.createTime.required': '创建时间必填',
    'cms.website.creator.label': '创建人',
    'cms.website.creator.holder': '請輸入创建人',

    'cms.website.creator.required': '创建人必填',
    'cms.website.updateTime.label': '更新时间',
    'cms.website.updateTime.holder': '請輸入更新时间',

    'cms.website.updateTime.required': '更新时间必填',
    'cms.website.updater.label': '更新人',
    'cms.website.updater.holder': '請輸入更新人',

    'cms.website.updater.required': '更新人必填',
    'cms.website.sort.label': '排序',
    'cms.website.sort.holder': '請輸入排序',
    'cms.website.sort.min': '排序最多0個字符',
    'cms.website.sort.max': '排序最多127個字符',
    'cms.website.sort.required': '排序必填',
    'cms.website.deleted.label': '是否删除',
    'cms.website.deleted.holder': '請輸入是否删除',

    'cms.website.deleted.required': '是否删除必填',
    'cms.website.tenantId.label': '租户Id',
    'cms.website.tenantId.holder': '請輸入租户Id',

    'cms.website.tenantId.required': '租户Id必填',
    'cms.website.version.label': 'version',
    'cms.website.version.holder': '請輸入version',

    'cms.website.version.required': 'version必填'
  },
  'en_US': {
    'cms.website.id.label': 'id',
    'cms.website.id.holder': 'Enter id',
    'cms.website.id.max': 'id max length: id',

    'cms.website.id.required': 'id required',
    'cms.website.code.label': 'code',
    'cms.website.code.holder': 'Enter code',
    'cms.website.code.max': 'code max length: 站点编码',
    'cms.website.code.min': 'code min length: 6',

    'cms.website.code.required': 'code required',
    'cms.website.name.label': 'name',
    'cms.website.name.holder': 'Enter name',
    'cms.website.name.max': 'name max length: 站点名称',
    'cms.website.name.min': 'name min length: 10',

    'cms.website.name.required': 'name required',
    'cms.website.logoUrl.label': 'logoUrl',
    'cms.website.logoUrl.holder': 'Enter logoUrl',
    'cms.website.logoUrl.max': 'logoUrl max length: 站点Logo',

    'cms.website.logoUrl.required': 'logoUrl required',
    'cms.website.publishUrl.label': 'publishUrl',
    'cms.website.publishUrl.holder': 'Enter publishUrl',
    'cms.website.publishUrl.max': 'publishUrl max length: 发布路径',

    'cms.website.publishUrl.required': 'publishUrl required',
    'cms.website.resRoot.label': 'resRoot',
    'cms.website.resRoot.holder': 'Enter resRoot',
    'cms.website.resRoot.max': 'resRoot max length: 资源路径',

    'cms.website.resRoot.required': 'resRoot required',
    'cms.website.defaultFlag.label': 'defaultFlag',
    'cms.website.defaultFlag.holder': 'Enter defaultFlag',
    'cms.website.defaultFlag.max': 'defaultFlag max length: 默认站点',

    'cms.website.defaultFlag.required': 'defaultFlag required',
    'cms.website.defWorkflowId.label': 'defWorkflowId',
    'cms.website.defWorkflowId.holder': 'Enter defWorkflowId',
    'cms.website.defWorkflowId.max': 'defWorkflowId max length: 审核流程',

    'cms.website.defWorkflowId.required': 'defWorkflowId required',
    'cms.website.memo.label': 'memo',
    'cms.website.memo.holder': 'Enter memo',
    'cms.website.memo.max': 'memo max length: 站点简介',

    'cms.website.memo.required': 'memo required',
    'cms.website.status.label': 'status',
    'cms.website.status.holder': 'Enter status',
    'cms.website.status.max': 'status max length: 状态',

    'cms.website.status.required': 'status required',
    'cms.website.deptId.label': 'deptId',
    'cms.website.deptId.holder': 'Enter deptId',
    'cms.website.deptId.max': 'deptId max length: 部门id',

    'cms.website.deptId.required': 'deptId required',
    'cms.website.createTime.label': 'createTime',
    'cms.website.createTime.holder': 'Enter createTime',
    'cms.website.createTime.max': 'createTime max length: 创建时间',

    'cms.website.createTime.required': 'createTime required',
    'cms.website.creator.label': 'creator',
    'cms.website.creator.holder': 'Enter creator',
    'cms.website.creator.max': 'creator max length: 创建人',

    'cms.website.creator.required': 'creator required',
    'cms.website.updateTime.label': 'updateTime',
    'cms.website.updateTime.holder': 'Enter updateTime',
    'cms.website.updateTime.max': 'updateTime max length: 更新时间',

    'cms.website.updateTime.required': 'updateTime required',
    'cms.website.updater.label': 'updater',
    'cms.website.updater.holder': 'Enter updater',
    'cms.website.updater.max': 'updater max length: 更新人',

    'cms.website.updater.required': 'updater required',
    'cms.website.sort.label': 'sort',
    'cms.website.sort.holder': 'Enter sort',
    // 'cms.website.sort.max': 'sort max length: 排序',
    'cms.website.sort.min': 'sort min length: 0',
    'cms.website.sort.max': 'sort max length: 127',
    'cms.website.sort.required': 'sort required',
    'cms.website.deleted.label': 'deleted',
    'cms.website.deleted.holder': 'Enter deleted',
    'cms.website.deleted.max': 'deleted max length: 是否删除',

    'cms.website.deleted.required': 'deleted required',
    'cms.website.tenantId.label': 'tenantId',
    'cms.website.tenantId.holder': 'Enter tenantId',
    'cms.website.tenantId.max': 'tenantId max length: 租户Id',

    'cms.website.tenantId.required': 'tenantId required',
    'cms.website.version.label': 'version',
    'cms.website.version.holder': 'Enter version',
    'cms.website.version.max': 'version max length: version',

    'cms.website.version.required': 'version required'
  }
}
